module.exports = __webpack_public_path__ + "img/FR18769.231bf45f.png";